import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const StepContent = ({ className, children }) => {
  const classes = classNames('ws-ui-step-line-content', className);

  return <div className={classes}>{children}</div>;
};

StepContent.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default StepContent;
